<template>
  <div class="blog-add my-5">
    <div class="progress-up" v-if="uploadPercentage > 0 && uploadPercentage !==  100">
      <div class="parent-loading">
        <b-progress
          show-progress
          animated
          :value="uploadPercentage"
          class="mt-2 w-100"
          :variant="'info'"
        ></b-progress>
      </div>
    </div>
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="container">
      <b-card>
        <div class="text-center">
          <img :src="image" :alt="form.title" class="mw-100"/>
          <!-- uploadImage -->
          <upload-blog-image
            apiImage="/blog/update-img-post"
            :id="$route.params.id"
            :isEdit="true"
            :width="368"
            :height="246"
            :circle="true"
          />
        </div>
        <div class="row">
          <div class="col-12 my-5"></div>
          <div class="col-9">
            <div class="group-form">
              <input
                type="text"
                v-validate="'required'"
                name="عنوان"
                :class="{active:form.title != '' }"
                v-model="form.title"
              />
              <span class="bar"></span>
              <label class="statr">عنوان مقاله</label>
              <span
                v-if="errors && errors.has('عنوان')"
                class="is-danger"
              >{{ errors.first('عنوان') }}</span>
            </div>
          </div>
          <div class="col-12">
            <div class="group-form">
              <textarea
                maxlength="100"
                type="text"
                v-model="form.description"
                :class="{active:form.description != ''}"
              ></textarea>
              <span class="bar"></span>
              <label for>توضیحات مختصر</label>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-2" v-if="form.subcategory_id">
              <category-drop-down-edit
                v-model="form.category"
                :category_id="form.category_id"
                :subcategory_id="form.subcategory_id"
                :isEdit="true"
              />
            </div>
          </div>
          <!-- <div class="col-12">
            <div class="mb-2">
              <tag :options="optionsTags"/>
            </div>
          </div>-->
          <div class="col-12">
            <tinymce-editor
              v-model="form.content"
              api-key="5jvyaeru3nfs1qb04au0hymmsfyrhspqo7qg0xp8cnc8ptl6"
              :init="configMedia"
            ></tinymce-editor>
          </div>
          <div class="col-12 mt-2">
            <label class="statr">فایل پیوست</label>

            <label for="pdf" class="input-group my-2">
              <div class="custom-file">
                <input
                  type="file"
                  accept=".pdf"
                  name="pdf"
                  id="pdf"
                  class="custom-file-input"
                  @change="uploadFile($event)"
                />
                <div
                  for="pdf"
                  class="custom-file-label"
                >{{form.pdf && form.pdf.name ? form.pdf.name : 'آپلود فایل'}}
                </div>
              </div>
              <div class="input-group-prepend">
                <span class="input-group-text">{{form.pdf ? 'ویرایش فایل' : 'آپلود فایل'}}</span>
              </div>
            </label>
            <a v-if="form.pdf && form.id" :href="urls.url.media + '/' + form.pdf" target="_blank">
              نمایش فایل
            </a>
          </div>
          <div class="col-12">
            <div class="mt-4 d-flex ">
              <m-btn class="ml-2" label="ذخیره به عنوان پیش نویس" @click.native="updateBlog({draft:true})"/>
              <m-btn class="ml-2" label="ذخیره و ارسال نهایی" @click.native="updateBlog({draft:false})"/>
              <m-btn label="انصراف" @click.native="canselEdit" type="danger"/>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
  import tag from "cp/min-component/tag/index.vue";
  import CategoryDropDownEdit from "cp/min-component/category-drop-down/fullmode.vue";
  import uploadBlogImage from "cp/blog/upload-image.vue";
  import MBtn from "cp/element/button";
  import MEditor from "cp/element/editor";
  import urls from "../../../constans"

  export default {
    name: "edit-blog",
    components: {
      tag,
      uploadBlogImage,
      CategoryDropDownEdit,
      MBtn,
      MEditor
    },
    data() {
      return {
        urls: urls,
        isLoading: true,
        uploadPercentageData: 0
      };
    },
    computed: {
      uploadPercentage() {
        return this.$store.state.InstructorForm.uploadPercentage;
      },
      form() {
        return this.$store.state.dashboardBlog.form;
      },
      optionsTags() {
        return this.$store.state.dashboardTag.tags;
      },
      tags() {
        return this.$store.state.dashboardTag.tagCourses;
      },
      image() {
        if (!this.form.imgSrc && this.form.img) {
          return this.appUrl.media + "/" + this.form.img;
        } else {
          return this.form.imgSrc;
        }
      }
    },
    mounted() {
      this.getData();
    },
    destroyed() {
      this.$store.dispatch("dashboardBlog/clearBlog");
    },
    methods: {
      canselEdit() {
        this.$router.push('/dashboard/blog/list');
      },
      async getData() {
        await this.$store.dispatch("dashboardBlog/getDetails", {
          id: parseInt(this.$route.params.id)
        });
        this.isLoading = false;
      },
      async uploadFile(e) {
        let files = e.target.files[0];
        if (!files) return;

        let filesize = (files.size / 1024 / 1024).toFixed(2); // MB
        if (filesize > 200) {
          this.$root.showWarnMsg({
            message: "حجم فایل نباید بیشتر از ۲۰۰ مگابایت باشد... "
          });
          return;
        }
        let formData = new FormData();
        formData.append('pdf', files);
        formData.append('id', this.form.id);

        let {data} = await axios.post("/blog/update-pdf-post", formData, {
          onUploadProgress: function (progressEvent) {
            this.uploadPercentageData = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }.bind(this)
        });
        if (data.state != 200) return;
        this.uploadPercentageData = 0;
        this.$store.commit(
          "notifications/success",
          {message: this.$t("message.request.done"), title: ""},
          {root: true}
        );
        this.form.pdf = files;
      },
      async updateBlog({draft}) {
        this.isLoading = true;
        let body = {...this.form}
        body.category_id = this.form.category.category_id
        body.subcategory_id = this.form.category.subcategory_id
        delete body.imgSrc;
        delete body.fullname;
        delete body.pub_date;
        delete body.img
        delete body.id
        delete body.pdf
        delete body.category
        body.as_draft = draft
        body.description = body.description ? body.description : ''
        let form = {
          id: parseInt(this.$route.params.id),
          ...body
        };
        let res = await this.$store.dispatch("dashboardBlog/update", form);
        if (res) {
          this.$router.push("/dashboard/blog/list");
        }
        this.isLoading = false;
      }
    }
  };
</script>
<style lang="stylus">
  .custom-file-label
    z-index 0

  .disabled
    pointer-events none
</style>




// WEBPACK FOOTER //
// src/pages/dashboard/blog/edit.vue